export const environment = {
  production: false,
  qa: true,
  url: "https://portal-test.airportbutler.com"
};